import React from 'react';
import { CordexaCoreLoader } from './CordexaCoreLoader';
import { RUNTIME_CORE_SPLASH_DEFAULT_STATUS } from './runtimeCoreSplashContent';
import styles from './RuntimeCoreSplash.module.css';

const RUNTIME_CORE_SPLASH_LOGO = '/assets/cortex-logo-horizontal-inverted.svg';

export type RuntimeCoreSplashProps = {
  statusMessage?: string;
  'data-testid'?: string;
};

export function RuntimeCoreSplash({
  statusMessage = RUNTIME_CORE_SPLASH_DEFAULT_STATUS,
  'data-testid': dataTestId = 'runtime-core-splash',
}: RuntimeCoreSplashProps) {
  return (
    <div
      className={styles.screen}
      data-testid={dataTestId}
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label={statusMessage}
    >
      <div className={styles.backgroundLayer} aria-hidden="true" />
      <div className={styles.overlay} aria-hidden="true" />

      <header className={styles.brandHeader}>
        <div className={styles.brandLockup}>
          <img
            src={RUNTIME_CORE_SPLASH_LOGO}
            alt=""
            aria-hidden="true"
            className={styles.logo}
          />
          <p className={styles.statusLine} data-testid="runtime-core-splash-status">
            {statusMessage}
          </p>
        </div>
      </header>

      <main className={styles.coreMain} aria-hidden="true">
        <div className={styles.coreGlow} aria-hidden="true" />
        <div className={styles.coreShell}>
          <CordexaCoreLoader variant="hero" />
        </div>
      </main>
    </div>
  );
}
